import { proxy, useSnapshot } from "valtio"
import { FlyingCarpetTab } from "./carpet-panels"

const store = proxy({
  isOpen: false,
  tab: null as null | FlyingCarpetTab,
  headerWidgetTarget: null as null | HTMLElement,
  getState() {
    return {
      isOpen: store.isOpen,
      tab: store.tab,
    }
  },
  launch(tab: FlyingCarpetTab) {
    store.isOpen = true
    store.tab = tab
  },
  close() {
    store.isOpen = false
  },
})

export const flyingCarpet = store

export function useFlyingCarpet() {
  return useSnapshot(store)
}
